import DataVisualizer from "./DataVisualizer";

export default function EmbedChart(){

  const params = new URLSearchParams(
    window.location.search
  );

  const startDate = params.get("start_date");
  const endDate = params.get("end_date");
  const range = params.get("range");


  return (
    <DataVisualizer
      embed={true}
      embedStartDate={startDate}
      embedEndDate={endDate}
      embedRange={range}
    />
  );
}